export default "__VITE_ASSET__DBkXikcd__"